import { TextInput, required } from 'react-admin';
import { OverrideInput } from '@/pages/Candidate/view/inputs';
import { DefaultToolbarStyled } from '@/styles/overrides';
import { path } from './constants';
import { OverrideLogicFormProps } from '../types';
import useController from './useController';

const FormContent = (props: OverrideLogicFormProps) => {
  const { handleOverride } = useController(props);

  return (
    <>
      <OverrideInput source={path('override_option')} validate={required()} />
      <TextInput source={path('override_reason')} validate={required()} />

      <DefaultToolbarStyled onClose={props.onClose} onSave={handleOverride} saveButtonLabel="Override" />
    </>
  );
};

export default FormContent;
